import type { ReactElement } from 'react';
import { Link } from 'react-router-dom';

import cambridgeLogoUrl from '../assets/cambridge-approved-by.svg';
import learnPlusLogoUrl from '../assets/learnplus-wordmark.svg';

/**
 * Wordmark at the top of the post-login parent and staff drawers.
 */
export function ConsoleSidebarBrand({ to }: { to: string }): ReactElement {
  return (
    <Link className="console-brand" to={to}>
      <img className="brand-lockup brand-lockup-on-navy" src={learnPlusLogoUrl} alt="Learn Plus" />
    </Link>
  );
}

/**
 * Cambridge International Education mark at the foot of the same drawers.
 */
export function ConsoleSidebarEndorsement(): ReactElement {
  return (
    <div className="console-endorsement">
      <img
        className="console-endorsement-mark"
        src={cambridgeLogoUrl}
        alt="Cambridge International Education"
      />
    </div>
  );
}
